export default "/images/6e21cf8fbc58cd58ec69f7e33067f35c.avif";